import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Table,
} from "react-bootstrap";
import { OneButton, TimeControlInbound } from "../components";
import { stringDateTimeReceipt, stringYMDHMS3 } from "../Utility/dateTime";
import TablePagination from '@mui/material/TablePagination';
import { goToTop } from "../Utility/function";
import { Modal_Inbound } from "../modal";
import * as XLSX from 'xlsx';
import { v4 as uuidv4 } from 'uuid';
import { colors } from "../configs";

const { dark, white } = colors;

const CategoryControl = ({ category, thisCategory, setThisCategory }) =>{

    return  <div style={{ display:'flex', width:'100%', overflowX:'auto', cursor:'pointer' }} >
                {category.map(a=>{
                    const { id, name } = a;
                    const status = id === thisCategory
                    return <div onClick={()=>{setThisCategory(id)}}  style={{minWidth:'100px', display:'flex', justifyContent:'center', backgroundColor:status?dark:white, color:status?white:dark, padding:10, margin:10, borderRadius:20 }} >
                                {name}
                            </div>
                })}
            </div>
}

function InboundHistoryScreen() {
    const { displayInbounds, startDate, endDate } = useSelector((state)=> state.inbound);
    const [inbound_Modal, setInbound_Modal] = useState(false);
    const [current, setCurrent] = useState({ createName:'', date:'', dateTime:new Date(), product:[], supplier:{} })

    const [currentDisplay, setCurrentDisplay] = useState([]) // จำนวนที่แสดงในหนึ่งหน้า
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const [category, setCategory] = useState([{ id:1, name:'ทั้งหมด' }]);
    const [thisCategory, setThisCategory] = useState(1);

    function openInbound(item){
        setCurrent({...item, product:item.product.map(a=>({...a, tempId:uuidv4()}))});
        setInbound_Modal(true)
    };
    
    useEffect(()=>{
        const supplierIds = new Set();
        const allSupplier = [];

        for (const item of displayInbounds) {
            const supplierId = item.supplier.id;
            if (!supplierIds.has(supplierId)) {
                supplierIds.add(supplierId);
                allSupplier.push({
                    id: supplierId,
                    name: item.supplier.vender_Name
                });
            }
        }
        setCategory([{ id:1, name:'ทั้งหมด' },  ...allSupplier])
    },[displayInbounds])

  
    const handleChangePage = (event, newPage) => {
        setPage(newPage); // start form 0
        goToTop()
    };
  
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        goToTop()
    };

    useEffect(()=>{
        let arr = displayInbounds
        if(thisCategory !== 1){
            arr = displayInbounds.filter(a=>a.supplier.id === thisCategory)
        }

        let fData = arr.map((item,index)=>{return({ ...item, no:index +1 })}).filter((item,index)=>{return(index >=(page*rowsPerPage) && index <= ((page+1)*rowsPerPage)-1)})
        setCurrentDisplay(fData);

       

    },[page,rowsPerPage,displayInbounds, thisCategory]);


  return (
    <div style={{minHeight:'100vh'}} >
        <Modal_Inbound
            show={inbound_Modal}
            onHide={()=>{setInbound_Modal(false)}}
            current={current}
            setCurrent={setCurrent}
            submit={()=>{}}
        />
        <h1>รายงานรับสินค้า</h1>
        <TimeControlInbound  />
        <CategoryControl {...{ thisCategory, setThisCategory, category }} />
        <h4>&emsp;ค้นพบ {displayInbounds.length} รายการ</h4> 
        <br/>
        <Table striped bordered hover responsive  variant="light"   >
            <thead  >
                <tr>
                    <th style={{textAlign:'center', width: '10%'}} >No.</th>
                    <th style={{textAlign:'center', width:'15%', minWidth:'120px' }} >เลขที่ใบสั่งซื้อ</th>
                    <th style={{textAlign:'center', width:'15%', minWidth:'120px' }} >วันเวลา</th>
                    <th style={{textAlign:'center', width:'15%', minWidth:'120px' }} >คู่ค้า</th>
                    <th style={{textAlign:'center', width:'15%', minWidth:'120px' }} >ราคาสุทธิ</th>
                    <th style={{textAlign:'center', width:'15%', minWidth:'120px' }} >เซลล์</th>
                    <th style={{textAlign:'center', width:'15%', minWidth:'120px' }} >ติดต่อ</th>
                    <th style={{textAlign:'center', width:'15%', minWidth:'120px' }} >ผู้รับ</th>
                    <th style={{textAlign:'center', width:'15%', minWidth:'120px' }} >รายละเอียด</th>

                </tr>
            </thead>
            <tbody  >
            {currentDisplay.map((item, index) => {
                const { dateTime, billNumber, totalCost, createName, supplier:{vender_Name, sale_Name, tel}, } = item;
                return <tr  style={{cursor: 'pointer'}} key={index} >
                            <td style={{textAlign:'center'}}>{index+1}.</td>
                            <td style={{textAlign:'center'}}>{billNumber}</td>
                            <td style={{textAlign:'center'}}>{stringDateTimeReceipt(dateTime)}</td>
                            <td style={{textAlign:'center'}}>{vender_Name}</td>
                            <td style={{textAlign:'center'}}>{totalCost?.toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2})}</td>
                            <td style={{textAlign:'center'}}>{sale_Name}</td>
                            <td style={{textAlign:'center'}}>{tel}</td>
                            <td style={{textAlign:'center'}}>{createName}</td>
                            <td style={{textAlign:'center'}}>
                                <OneButton {...{ text:"จัดการ", variant:'warning', submit:()=>{openInbound(item)} }} />
                            </td>
                        </tr>
            })}
            </tbody>
        </Table>
        <TablePagination
            component="div"
            count={displayInbounds.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
        />
    </div>
  );
};

const styles = {
    container2 : {
      display:'flex',justifyContent:'space-between',marginRight:'1rem'
    },
 
  }

export default InboundHistoryScreen;